import { useTranslations } from '@/hooks/useTranslations';

export const InvoiceType = ({
  type,
}: {
  type: 'Invoice' | 'Proforma Invoice' | 'Offer';
}) => {
  const enums = useTranslations('Enums');

  let typeMessage;

  switch (type) {
    case 'Invoice':
      typeMessage = (
        <div className="flex justify-center items-center border px-3 py-0.5 rounded-full bg-info/10">
          <span className="bg-info w-2 h-2 rounded mr-1" />

          <p>{enums('invoiceType.invoice')}</p>
        </div>
      );
      break;

    case 'Proforma Invoice':
      typeMessage = (
        <div className="flex justify-center items-center border px-3 py-0.5 rounded-full bg-warning/10">
          <span className="bg-warning w-2 h-2 rounded mr-1" />

          <p>{enums('invoiceType.proformaInvoice')}</p>
        </div>
      );
      break;

    case 'Offer':
      typeMessage = (
        <div className="flex justify-center items-center border px-3 py-0.5 rounded-full bg-chart-3/10">
          <span className="bg-chart-3 w-2 h-2 rounded mr-1" />

          <p>{enums('invoiceType.offer')}</p>
        </div>
      );
      break;

    default:
      typeMessage = <p></p>;
  }

  return <div className="flex">{typeMessage}</div>;
};
